import { Injectable } from '@angular/core';
import {
  PComparatorProductsRequest,
  PRODUCT_COMPARATOR_TYPE,
  ProductComparatorFloating,
  PComparatorStatusRequest,
} from './product-comparator.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ProductComparatorAdapter } from './product-comparator.adapter';

@Injectable({
  providedIn: 'root',
})
export class ProductComparatorService {
  store$ = new BehaviorSubject<ProductComparatorFloating>({ products: [] });

  constructor(
    private activatedRoute: ActivatedRoute,
    private productComparatorAdapter: ProductComparatorAdapter,
  ) {}

  getCurrentComparationType(): PRODUCT_COMPARATOR_TYPE {
    let comparationType = PRODUCT_COMPARATOR_TYPE.CROSS_REFERENCE;

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['pids']) {
        comparationType = PRODUCT_COMPARATOR_TYPE.FLOATTING;
      }
    });

    return comparationType;
  }

  getPComparator(config: PComparatorProductsRequest): Observable<PComparatorStatusRequest> {
    return this.productComparatorAdapter.getPComparator(config);
  }
}
